<template>
  <div class="page_all">
    <loading
      :active.sync="isLoading"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
    <div class="return_link">
      <router-link to="/printList">＜ 印刷設定</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">印刷設定</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div class="header_button_group" v-if="isTemplateSelected">
        <!-- <div class="header_button_group_row">
          <button class="btn_general" :disabled="$v.$invalid || this.updating || this.downloading" v-on:click="onClickDownloadImage1">PNGのダウンロード（1ページ目）</button>
          <button class="btn_general" :disabled="$v.$invalid || this.updating || this.downloading" v-on:click="onClickDownloadImage2">PNGのダウンロード（2ページ目）</button>
        </div> -->
        <div class="header_button_group_row">
          <button class="btn_general" v-if="!updatedFlg" :disabled="$v.$invalid || this.updating || this.downloading" v-on:click="onClickSave(1)">クリア</button>
          <!-- <button class="btn_general" :disabled="$v.$invalid || this.updating || this.downloading" v-on:click="onClickDownloadEprint">プリント</button> -->
          <button class="btn_general" :disabled="$v.$invalid || this.updating || this.downloading" v-on:click="onClickDownloadPdf">PDFのダウンロード</button>
          <button class="btn_general" :disabled="$v.$invalid || this.updating || this.downloading" v-on:click="onClickSave(0)">保存</button>
        </div>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main" v-if="isPrintSettingLoaded">
        <thead>
        <tr>
          <th>テンプレートの選択</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <div>使用するテンプレートを選択してください</div>
            <div>
              <label>
                <input name="template_type" type="radio" :value="1" v-model="templateType">
                台風
              </label>
            </div>
            <div>
              <label>
                <input name="template_type" type="radio" :value="2" v-model="templateType">
                大雨
              </label>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <br/>

      <table class="tbl_main" v-if="isTemplateSelected">
        <thead>
        <tr>
          <th colspan="2">画像の設定</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <div style="display: flex;">
              <div class="upload_image_cell">
                <div style="display: flex; ">
                  <button class="btn_general" v-on:click="$refs.file_logo_image.click()">ロゴの設定</button>
                  <input class="file_input" type="file" ref="file_logo_image" name="logo_image"
                         @change="onSelectLogoImage">
                  <div class="upload_thumbnail_image_frame">
                    <img accept="image/*" class="upload_thumbnail_image" id="img_logo_image" :src="logoImageThumbnail">
                  </div>
                  <button v-if="logoImageThumbnail" class="btn_delete" v-on:click="logoImageThumbnail = null">X</button>
                </div>
                <div class="image_description">※対象ファイルは png, jpeg, jpg</div>
                <div class="image_description">最大サイズは1000x1000になります。</div>
              </div>
              <div class="upload_image_cell" v-if="additionalImageEnable">
                <div style="display: flex;">
                  <button class="btn_general" v-on:click="$refs.file_additional_image.click()">画像の添付</button>
                  <input class="file_input" type="file" ref="file_additional_image" @change="onSelectAdditionalImage1">
                  <div class="upload_thumbnail_image_frame">
                    <img accept="image/*" class="upload_thumbnail_image" id="img_additional_image" :src="additionalImage1Thumbnail">
                  </div>
                  <button v-if="additionalImage1Thumbnail" class="btn_delete" v-on:click="additionalImage1Thumbnail = null">X</button>
                </div>
                <div class="image_description">※対象ファイルは png, jpeg, jpg</div>
                <div class="image_description">最大サイズは6000x6000になります。</div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <br/>

      <table class="tbl_main" v-if="isTemplateSelected">
        <thead>
        <tr>
          <th>推奨する行動</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <div style="display: flex; flex-direction: column;">
              <label class="input_label">
                3日前～1日前 程度
                <textarea class="input_text_area" :maxlength="TEXT_VALUE_LENGTH_MAX" rows="5" v-model="from3DaysTo1Day"/>
              </label>
              <label class="input_label">
                1日前～半日前 程度
                <textarea class="input_text_area" :maxlength="TEXT_VALUE_LENGTH_MAX" rows="5" v-model="from1DaysToHalfDay"/>
              </label>
              <label class="input_label">
                半日前～6時間前 程度
                <textarea class="input_text_area" :maxlength="TEXT_VALUE_LENGTH_MAX" rows="5" v-model="fromHalfDayTo6Hours"/>
              </label>
              <label class="input_label">
                6時間前～3時間前 程度
                <textarea class="input_text_area" :maxlength="TEXT_VALUE_LENGTH_MAX" rows="5" v-model="from6HoursTo3Hours"/>
              </label>
              <label class="input_label">
                3時間前～1時間前 程度
                <textarea class="input_text_area" :maxlength="TEXT_VALUE_LENGTH_MAX" rows="5" v-model="from3HoursTo1Hour"/>
              </label>
              <label class="input_label">
                0時間前
                <textarea class="input_text_area" :maxlength="TEXT_VALUE_LENGTH_MAX" rows="5" v-model="from0Hour"/>
              </label>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="クリア" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import {required, maxLength, numeric} from 'vuelidate/lib/validators'
import ConfirmDialog from "@/components/ConfirmDialog";

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

const TemplateType = {
  Unselected: 0,
  Typhoon: 1,
  HeavyRain: 2,
};
const TEXT_VALUE_LENGTH_MAX = 500;

export default {
  components: {
    ConfirmDialog,
    "loading":Loading
  },
  data: function () {
    return {
      TEXT_VALUE_LENGTH_MAX,
      // 変更フラグ
      changeFlg: false,
      // メッセージ
      message: "",

      printSettingId: null,
      templateType: null, // null: not loaded, 0: unselected, 1: 台風, 2: 大雨,
      logoImage: "",
      logoImageThumbnail: "",
      additionalImage1: "",
      additionalImage1Thumbnail: "",
      from3DaysTo1Day: "",
      from1DaysToHalfDay: "",
      fromHalfDayTo6Hours: "",
      from6HoursTo3Hours: "",
      from3HoursTo1Hour: "",
      from0Hour: "",

      updating: false,
      downloading: false,
      updatedFlg: false,
      isLoading: false,
      fullPage: true,
    }
  },
  computed: {
    disasterId: function () {
      return this.$store.getters.getStatePrintDisasterId
    },
    isPrintSettingLoaded: function () {
      return this.templateType !== null;
    },
    isTyphoon: function () {
      return parseInt(this.templateType, 10) === TemplateType.Typhoon;
    },
    isHeavyRain: function () {
      return parseInt(this.templateType, 10) === TemplateType.HeavyRain;
    },
    isTemplateSelected: function () {
      return this.isTyphoon || this.isHeavyRain;
    },
    additionalImageEnable: function () {
      return false;
    },
  },
  mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // 変更の場合は詳細情報取得
    if (this.changeFlg) {
      (async () => {
        console.log(this.disasterId)
        const printSetting = await this.getPrintSettingDetail()
        // クリアボタン表示判定
        this.updatedFlg = printSetting.template_type == 1 || printSetting.template_type == 2 ? false : true
        this.setPrintSetting(printSetting);
      })();
    }
  },
  methods: {
    async checkImageFile(file, size) {
      this.message = "";
      if (!file) {
        return false;
      }
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.message = "png, jpeg, jpg のみに対応しています。";
        return false;
      }
      return await new Promise((resolve) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);
        const that = this;
        image.onload = function () {
          URL.revokeObjectURL(objectUrl);
          const fixed = this.width <= size && this.height <= size;
          if (!fixed) {
            that.message = `最大サイズは${size}x${size}になります。`;
          }
          resolve(fixed);
        };
        image.src = objectUrl;
      });
    },
    async onSelectLogoImage(event) {
      const file = event.target.files[0];
      if (!await this.checkImageFile(file, 1000)) {
        return;
      }
      this.logoImage = file;
      const reader = new FileReader()
      reader.onload = () => {
        this.logoImageThumbnail = reader.result;
      }
      reader.readAsDataURL(this.logoImage);
    },
    async onSelectAdditionalImage1(event) {
      const file = event.target.files[0];
      if (!await this.checkImageFile(file, 6000)) {
        return;
      }
      this.additionalImage1 = file;
      const reader = new FileReader()
      reader.onload = () => {
        this.additionalImage1Thumbnail = reader.result;
      }
      reader.readAsDataURL(this.additionalImage1);
    },
    getUpdateValuesParam() {
      switch (this.templateType) {
        case TemplateType.Typhoon:
        case TemplateType.HeavyRain:
          return {
            "from3DaysTo1Day": this.from3DaysTo1Day || "",
            "from1DaysToHalfDay": this.from1DaysToHalfDay || "",
            "fromHalfDayTo6Hours": this.fromHalfDayTo6Hours || "",
            "from6HoursTo3Hours": this.from6HoursTo3Hours || "",
            "from3HoursTo1Hour": this.from3HoursTo1Hour || "",
            "from0Hour": this.from0Hour || "",
          };
        default:
          return {};
      }
    },
    setPrintSetting(printSetting) {
      if (printSetting) {
        this.templateType = printSetting.template_type || 0;
        if (printSetting.values) {
          this.from3DaysTo1Day = printSetting.values["from3DaysTo1Day"] || "";
          this.from1DaysToHalfDay = printSetting.values["from1DaysToHalfDay"] || "";
          this.fromHalfDayTo6Hours = printSetting.values["fromHalfDayTo6Hours"] || "";
          this.from6HoursTo3Hours = printSetting.values["from6HoursTo3Hours"] || "";
          this.from3HoursTo1Hour = printSetting.values["from3HoursTo1Hour"] || "";
          this.from0Hour = printSetting.values["from0Hour"] || "";
        }
        if (printSetting.images) {
          this.logoImage = null;
          this.additionalImage1 = null;
          this.logoImageThumbnail = printSetting.images.logoImage && printSetting.images.logoImage.url || "";
          this.additionalImage1Thumbnail = printSetting.images.additionalImage1 && printSetting.images.additionalImage1.url || "";
        }
      }
    },
    isChangedFile(thumbnail) {
      if (typeof thumbnail !== "string" || thumbnail === null || thumbnail === undefined) { // 削除
        return true;
      }
      if (thumbnail === "") {
        return false;
      }
      const pattern = new RegExp(/^https?:\/\//);
      return !pattern.test(thumbnail); // URLでない場合、ファイルデータ。更新あり
    },
    async onClickDownloadEprint() {
      await this.onClickDownloadImpl("eprint", "application/json", "json");
    },
    async onClickDownloadImage1() {
      await this.onClickDownloadImpl("image", "image/png", "png", {pageNumber: 1});
    },
    async onClickDownloadImage2() {
      await this.onClickDownloadImpl("image", "image/png", "png", {pageNumber: 2});
    },
    async onClickDownloadPdf() {
      await this.onClickDownloadImpl("pdf", "application/pdf", "pdf");
    },
    async onClickDownloadImpl(kind, contentType, extension, extra = {}) {
      this.message = "";
      this.downloading = true;
      var sections = [];
      // testデータ作成
      // while (Math.random() > 0.1) {
      //   const dayOffset = - Math.floor(Math.random() * 3);
      //   const hourOffset = - Math.floor(Math.random() * 24);
      //   const events = [];
      //   let eventIndex = 0;
      //   while (Math.random() > 0.5) {
      //     events.push(`dayOffset: ${dayOffset}, hourOffset: ${hourOffset} サンプルデータイベント${eventIndex}`);
      //     eventIndex++;
      //   }
      //   sections.push({dayOffset, hourOffset, events});
      // }
    //   const evacuation = {
    //     "shelter": "住民は「自らの命は自らが守る」意識を持ち、自らの判断で避難行動をとるとの方針が示され、この方針に沿って自治体や気象庁等から発表される防災情報を用いて住民がとるべき行動を直感的に理解しやすくなるよう、５段階の警戒レベルを明記して防災情報が提供されることとなっています。",
    //     "together": "避難にあたっては、あらかじめ指定された避難場所へ向かうことにこだわらず、川や崖から少しでも離れた、近くの頑丈な建物の上層階に避難するなど、自らの判断でその時点で最善の安全確保行動をとることが重要です。",
    //     "warn": "自治体から警戒レベル４避難指示や警戒レベル３高齢者等避難が発令された際には速やかに避難行動をとってください。一方で、多くの場合、防災気象情報は自治体が発令する避難指示等よりも先に発表されます。このため、危険な場所からの避難が必要とされる警戒レベル４や高齢者等の避難が必要とされる警戒レベル３に相当する防災気象情報が発表された際には、避難指示等が発令されていなくてもキキクル（危険度分布）や河川の水位情報等を用いて自ら避難の判断をしてください。"
    // }
    //   sections = [
    //     {
    //         "dayOffset": -3,
    //         "events": [
    //             "避難情報に関するガイドラインの改定（令和3年5月）\\n\\n\u3000中央防災会議、防災対策実行会議の下の「令和元年台風第19号等による災害からの避難に関するワーキンググループ」からの提言が令和２年３月にとりまとめられ、 本提言を踏まえ引き続き制度的な論点を議論した「令和元年台風第19号等を踏まえた避難情報及び広域避難等に関するサブワーキンググループ」からの提言が令和２年１２月にとりまとめられました。\\n\u3000サブワーキンググループからの提言を踏まえ、災害対策基本法が令和３年に改正（災害対策基本法等の一部を改正する法律（令和３年法律第３０号）：５月１０日公布、５月２０日施行）されたことを受け、市町村が避難情報の発令基準等を検討・修正等する際の参考としていただけるよう、これまでの「避難勧告等に関するガイドライン」を名称を含め改定し、「避難情報に関するガイドライン」として公表します。"
    //         ]
    //     },
    //     {
    //         "dayOffset": -1,
    //         "events": [
    //             "災害への心構えを高める必要があることを示す警戒レベル１です。\\n\u3000最新の防災気象情報等に留意するなど、災害への心構えを高めてください。",
    //             "避難行動の確認が必要とされる警戒レベル２です。\\n\u3000ハザードマップ等により、災害が想定されている区域や避難先、避難経路を確認してください。"
    //         ]
    //     },
    //     {
    //         "hourOffset": -12,
    //         "events": [
    //             "避難行動の確認が必要とされる警戒レベル２に相当します。\\n\u3000ハザードマップ等により、災害が想定されている区域や避難先、避難経路を確認してください。"
    //         ]
    //     },
    //     {
    //         "hourOffset": -5,
    //         "events": [
    //             "地元の自治体が警戒レベル３高齢者等避難を発令する目安となる情報です。高齢者等は危険な場所からの避難が必要とされる警戒レベル３に相当します。\\n\u3000災害が想定されている区域等では、自治体からの高齢者等避難の発令に留意するとともに、高齢者等以外の方もキキクル（危険度分布）や河川の水位情報等を用いて避難の準備をしたり自ら避難の判断をしたりしてください。"
    //         ]
    //     },
    //     {
    //         "hourOffset": -3,
    //         "events": [
    //             "地元の自治体が警戒レベル４避難指示を発令する目安となる情報です。危険な場所からの避難が必要とされる警戒レベル４に相当します。\u3000\\n\u3000災害が想定されている区域等では、自治体からの避難指示の発令に留意するとともに、避難指示が発令されていなくてもキキクル（危険度分布）や河川の水位情報等を用いて自ら避難の判断をしてください。"
    //         ]
    //     },
    //     {
    //         "hourOffset": 0,
    //         "events": [
    //             "地元の自治体が警戒レベル５緊急安全確保を発令する判断材料となる情報です。災害が発生又は切迫していることを示す警戒レベル５に相当します。\\n\u3000何らかの災害がすでに発生している可能性が極めて高い状況となっています。命の危険が迫っているため直ちに身の安全を確保してください。"
    //         ]
    //     }
    // ]
 
      const {response, error} = await this.$axios.post(process.env.VUE_APP_API_BASEURL + `v1/mytimeline/print/${kind}`, {
        disasterId: this.disasterId,
        sections: sections,
        // evacuation: evacuation,
        ...extra,
      }, {
        headers: {
          'Accept': contentType,
        },
        responseType: "blob",
      }).then(response => ({response})).catch(error => ({error}));
      this.downloading = false;
      if (error) {
        this.message = error;
        return null;
      }

      const blob = new Blob([response.data], {type: response.headers["content-type"]});
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, `print.${extension}`);
      } else {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `print.${extension}`;
        link.click();
        URL.revokeObjectURL(link.href)
      }
    },
    async onClickSave(deleteFlg) {
      // クリアダイアログ
      if (deleteFlg == 1) {
        var templateStr = this.templateType == 1 && "台風" || "大雨" 
        const result = await this.$refs.deleteDialog.asyncShow(templateStr + `の印刷設定をクリアしてよろしいですか？`)
        if (!result) {
          return
        }
      }

      this.isLoading = true
      this.message = "";
      // 印刷設定の登録
      const printSetting = await this.savePrintSettingImpl(this.templateType, this.getUpdateValuesParam(), deleteFlg);
      this.setPrintSetting(printSetting);
      this.updatedFlg = printSetting.template_type == 1 || printSetting.template_type == 2 ? false : true
      // ロゴ画像のアップロード、又は削除
      if (this.isChangedFile(this.logoImageThumbnail) || deleteFlg == 1) {
        const logoImageUrl = await this.saveImageImpl("logoImage", this.logoImage, deleteFlg);
        this.logoImage = null;
        if (logoImageUrl) {
          this.logoImageThumbnail = logoImageUrl;
        } else {
          this.logoImageThumbnail = ""
        }
      }
      // 添付画像のアップロード、又は削除
      if (this.isChangedFile(this.additionalImage1Thumbnail) || deleteFlg == 1) {
        const additionalImage1Url = await this.saveImageImpl("additionalImage1", this.additionalImage1, deleteFlg);
        this.additionalImage1 = null;
        if (additionalImage1Url) {
          this.additionalImage1Thumbnail = additionalImage1Url;
        } else {
          this.additionalImage1Thumbnail = ""
        }
      }

      // クリアボタン表示判定用に再取得
      if (deleteFlg == 1) {
        this.updating = true
        const printSetting = await this.getPrintSettingDetail()
        this.updatedFlg = printSetting.template_type == 1 || printSetting.template_type == 2 ? false : true
        this.setPrintSetting(printSetting);
        this.updating = false
      }
      this.isLoading = false
    },
    async savePrintSettingImpl(template_type, values, deleteFlg) {
      this.updating = true;
      const {response, error} = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'print-setting/update', {
        disaster_id: this.disasterId, template_type, values, 
        delete_flg: deleteFlg,
        print_setting_id: this.printSettingId
      }).then(response => ({response})).catch(error => ({error}));
      this.updating = false;
      if (error) {
        this.message = error;
        return null;
      }
      return response.data;
    },
    async saveImageImpl(name, file, deleteFlg) {
      this.updating = true
      if (file != "" || file != null) {
        var toBase64 = file => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        })
      }
      const data = {
        "image": deleteFlg == 1 || file == "" || file == null ? null : (await toBase64(file)).replace(/data:.*\/.*;base64,/, ''),
        "image_type": deleteFlg == 1 || file == "" || file == null ? null : file.type,
        "delete_flg": deleteFlg
      }
      const {response, error} = await this.$axios.post(process.env.VUE_APP_API_BASEURL + `print-setting/image/${this.disasterId}/${name}/`
                                                      , data
                                                      // , {
                                                      // headers: {'Content-Type': file && file.type || ''
                                                      // },
                                                      , {headers: {'Content-Type': "test/json"},}
      ).then(response => ({response})).catch(error => ({error}));
      this.updating = false;
      if (error) {
        this.message = error;
        return null;
      }
      return response.data.url || null;
    },
    async getPrintSettingDetail() {
      const {response, error} = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'print-setting/detail', {
        params: {
          disaster_id: this.disasterId,
        }
      }).then(response => ({response})).catch(error => ({error}));
      if (error) {
        if (error.response && error.response.status === 404) {
          return {};
        }
        this.message = error;
        return null;
      }
      return response.data;
    },
    onCancel:function() {
      console.log('User cancelled the loader.')
    },
  },
  validations: {
    templateType: {
      required,
      numeric,
    },
    from3DaysTo1Day: {
      maxLength: maxLength(TEXT_VALUE_LENGTH_MAX),
    },
    from1DaysToHalfDay: {
      maxLength: maxLength(TEXT_VALUE_LENGTH_MAX),
    },
    fromHalfDayTo6Hours: {
      maxLength: maxLength(TEXT_VALUE_LENGTH_MAX),
    },
    from6HoursTo3Hours: {
      maxLength: maxLength(TEXT_VALUE_LENGTH_MAX),
    },
    from3HoursTo1Hour: {
      maxLength: maxLength(TEXT_VALUE_LENGTH_MAX),
    },
    from0Hour: {
      maxLength: maxLength(TEXT_VALUE_LENGTH_MAX),
    },
  }
}
</script>

<style scoped>
/* 登録内容 */
table tr {
  border: none;
}

table th {
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
}

table td {
  text-align: left;
  padding: 10px;
}

.btn_delete {
  text-align: left;
  border-left: none;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 20px;
  font-weight: bold;
}

.btn_general {
  margin-left: 5px;
  min-width: 100px;
}

.upload_image_cell {
  width: 50%;
}
.upload_thumbnail_image_frame {
  margin-left: 10px;
  width: 100px;
  height: 100px;
  position: relative;
}
.upload_thumbnail_image {
  max-width: 100px;
  max-height: 100px;
  position: absolute;
  top: 50px;
  left: 50px;
  transform: translate(-50%, -50%);
}

.image_description {
  font-size: 14px;
}

.file_input {
  display: none;
}

.input_label {
  font-size: 20px;
}

.input_text_area {
  width: 100%;
  font-size: 12px;
}
.header_button_group_row {
  text-align: right;
  margin-top: 10px;
}

</style>